import React from 'react'
import { BookView } from '../components/BookView'
import { BackButton } from '../components/BackButton'
import { FaUsers } from 'react-icons/fa'

export function BookViewPage() {
  return (
    <>
      <BackButton to="/books" icon={<FaUsers data-set="user-icon" />}>
        <span>Books</span>
      </BackButton>
      <BookView />
    </>
  )
}
